export default __webpack_public_path__ + "static/media/nationalparks@3x.65fa8685.png";